import { put, takeLatest } from "redux-saga/effects";
import { sinhVienDangKyThucTapApi } from "../../../api/xet-thuc-tap/sinhVienDangKyThucTapApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eSinhVienDangKyThucTapActionIds, ISinhVienDangKyThucTapActionType } from "../../action-types/xet-thuc-tap/ISinhVienDangKyThucTapActions";
import { rootActions } from "../../actions/rootActions";
import exp from "constants";

export function* sinhVienDangKyThucTapSaga(): any {
    yield takeLatest(eSinhVienDangKyThucTapActionIds.LOAD_BY_DOT_THUC_TAP_START, loadByDotThucTapWorker);
}

function* loadByDotThucTapWorker(action: ISinhVienDangKyThucTapActionType) : any {
    const id_dot_thuc_tap = action.payload as number;
    const response: IBaseResponse = yield sinhVienDangKyThucTapApi.SelectByDotThucTap(id_dot_thuc_tap);
    if (response.is_success) {
        yield put(rootActions.xetThucTap.sinhVienDangKyThucTap.LOAD_BY_DOT_THUC_TAP_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.xetThucTap.sinhVienDangKyThucTap.LOAD_BY_DOT_THUC_TAP_ERROR(response.message ?? "Lỗi khi tải danh sách sinh viên đăng ký thực tập"));
    }
}